import { configureStore } from "@reduxjs/toolkit";

import authReducer from "./auth/authSlice";
import formsSlice from "./forms/formsSlice";
import pageNameSlice from "./pageName/pageNameSlice";
import registerSlice from "./register/registerSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    pageName: pageNameSlice,
    formsOptions: formsSlice,
    register: registerSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
